import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, LayersIcon, EyeIcon, ActivityIcon, ClipboardCheckIcon, TargetIcon, FolderIcon } from 'lucide-react';
const benefits = [{
  icon: ClockIcon,
  title: 'Préparez vos cours plus rapidement',
  detail: 'Les supports existent déjà : vous choisissez au lieu de tout recréer.'
}, {
  icon: EyeIcon,
  title: 'Des schémas et représentations déjà prêts',
  detail: 'Une grande partie du travail visuel est faite, pour appuyer vos explications.'
}, {
  icon: LayersIcon,
  title: 'Une base déjà structurée',
  detail: 'Chaque notion suit une progression claire, de l’observation au modèle.'
}, {
  icon: ActivityIcon,
  title: 'Trouvez vite une activité adaptée',
  detail: 'Activités courtes, séquences et exercices classés par notion et par usage.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Préparez vos contrôles sans tout reconstruire',
  detail: 'Évaluations, versions A/B lorsqu’elles existent, barèmes et corrigés.'
}, {
  icon: TargetIcon,
  title: 'Différenciez et remédiez plus facilement',
  detail: 'Une même notion déclinée sur trois niveaux, prête à utiliser.'
}, {
  icon: FolderIcon,
  title: 'Tout dans une seule bibliothèque',
  detail: 'À imprimer ou à projeter, au lieu de fichiers dispersés dans plusieurs dossiers.'
}];
export function BenefitsSection() {
  return <section className="w-full bg-cobalt/5 px-5 py-8 sm:py-12" data-id="element-39" data-mp="1sgtkz21ii654">
      <div className="mx-auto max-w-5xl" data-id="element-40" data-mp="1ofhuyveq7iwe">
        <div className="mx-auto max-w-2xl text-center" data-id="element-41" data-mp="1ogj58xnx41d2">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-42" data-mp="22er9lqnaa4y9">
            Ce que cela change concrètement dans votre semaine
          </h2>
          <p className="mt-2 text-sm text-ink/70 sm:mt-3 sm:text-base" data-id="element-43" data-mp="3dtebdkpt513m">
            L’objectif n’est pas d’ajouter des fichiers à votre disque dur, mais de raccourcir le
            chemin entre l’idée de la séance et la séance elle-même.
          </p>
        </div>

        <ul className="mt-6 grid gap-3 sm:mt-10 sm:gap-4 md:grid-cols-2" data-id="element-44" data-mp="3gxc0f5pu9lgy">
          {benefits.map((benefit, i) => <motion.li key={benefit.title} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-3 rounded-xl bg-white p-4 shadow-sm shadow-cobalt/5 sm:p-5 md:last:col-span-2" data-id="element-45" data-mp="3pvxpzktqa0r8" data-mpi={i}>
              <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-cobalt/10 text-cobalt-deep" data-id="element-46" data-mp="374eo5hbfwsqs">
                <benefit.icon className="h-4 w-4" aria-hidden="true" data-id="element-47" data-mp="3bxhap5hsv1xh" />
              </span>
              <div className="min-w-0" data-id="element-48" data-mp="2eg91gp0tstob">
                <h3 className="text-sm font-bold leading-snug text-ink sm:text-base" data-id="element-49" data-mp="2jfvd4u10a1v0">
                  {benefit.title}
                </h3>
                <p className="mt-1 text-[13px] leading-relaxed text-ink/70 sm:text-sm" data-id="element-50" data-mp="2bv1cbk1hf0cb">
                  {benefit.detail}
                </p>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}